<template>
  <div>
    <!-- 切换 -->
    <van-field
      v-model="tabActiveName"
      is-link
      label-width="40"
      readonly
      name="picker"
      label="分类"
      placeholder="点击选择试题分类"
      @click="showPicker = true"
    />
    <van-popup v-model:show="showPicker" position="bottom">
      <van-picker
        :columns="tabNames"
        @confirm="tabConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
    <!-- 试题 -->
    <div class="container" v-if="tabActiveName === '全部'">
      <div class="alert">
        <van-row>
          <van-col span="8">正确：{{rightNum}}</van-col>
          <van-col span="8">错误：{{errorNum}}</van-col>
          <van-col span="8">正确率：{{acc}}%</van-col>
        </van-row>
      </div>
      <dl class="exercise ueditor_style" ref="questions">
        <!-- 判断题 -->
        <dt v-if="judgeChoice.length > 0"><span>判断题</span></dt>
        <dd v-if="judgeChoice.length > 0">
          <ul>
            <li v-for="(item, index) in judgeChoice" :key="item.paper_question_id">
              <div class="no">{{ index+1 }}.</div>
              <div class="content" >
                <div class="stem" v-html="item.stem"></div>
                <div class="options">
                  <van-radio-group v-model="item.selected" :disabled="hasSubmit">
                    <van-radio name="1" key="1">
                      <div class="opts_wrap">
                        <div class="opts_content"><p>对</p></div>
                      </div>
                    </van-radio>
                    <van-radio name="0" key="0">
                      <div class="opts_wrap">
                        <div class="opts_content"><p>错</p></div>
                      </div>
                    </van-radio>
                  </van-radio-group>
                </div>
                <div class="analysis" v-if="hasSubmit">
                  <div class="answer">
                    <span class="success" v-if="item.is_right"><van-icon name="success" />回答正确</span>
                    <span class="error" v-else><van-icon name="cross" />回答错误</span>
                    <span>正确答案：{{ item.answer_str }}</span>
                  </div>
                  <div class="tip" v-if="item.analysis">
                    <van-tag color="#e6f7fd" text-color="#00adef" size="medium">试题解析</van-tag>
                    <p v-html="item.analysis"></p>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </dd>
        <!-- 单选题 -->
        <dt v-if="singleChoiceList.length > 0"><span>单选题</span></dt>
        <dd v-if="singleChoiceList.length > 0">
          <ul>
            <li v-for="(item, index) in singleChoiceList" :key="item.paper_question_id">
              <div class="no">{{ index+1 }}.</div>
              <div class="content" >
                <div class="stem" v-html="item.stem"></div>
                <div class="options">
                  <van-radio-group v-model="item.selected" :disabled="hasSubmit">
                    <van-radio v-for="option in item.options" :name="option.identification" :key="option.identification">
                      <div class="opts_wrap">
                        <div class="opts_no">{{option.identification}}. </div>
                        <div class="opts_content" v-html="option.option"></div>
                      </div>
                    </van-radio>
                  </van-radio-group>
                </div>
                <div class="analysis" v-if="hasSubmit">
                  <div class="answer">
                    <span class="success" v-if="item.is_right"><van-icon name="success" />回答正确</span>
                    <span class="error" v-else><van-icon name="cross" />回答错误</span>
                    <span>正确答案：{{ JSON.parse(item.answer).join(',') }}</span>
                  </div>
                  <div class="tip" v-if="item.analysis">
                    <van-tag color="#e6f7fd" text-color="#00adef" size="medium">试题解析</van-tag>
                    <p v-html="item.analysis"></p>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </dd>
        <!-- 多选题 -->
        <dt v-if="multipleChoice.length > 0"><span>多选题</span></dt>
        <dd v-if="multipleChoice.length > 0">
          <ul>
            <li v-for="(item, index) in multipleChoice" :key="item.paper_question_id">
              <div class="no">{{ index+1 }}.</div>
              <div class="content" >
                <div class="stem" v-html="item.stem"></div>
                <div class="options">
                  <van-checkbox-group v-model="item.selected" :disabled="hasSubmit">
                    <van-checkbox shape="square" :name="option.identification" v-for="option in item.options" :key="option.identification">
                      <div class="opts_wrap">
                        <div class="opts_no">{{option.identification}}. </div>
                        <div class="opts_content" v-html="option.option"></div>
                      </div>
                    </van-checkbox>
                  </van-checkbox-group>
                </div>
                <div class="analysis" v-if="hasSubmit">
                  <div class="answer">
                    <span class="success" v-if="item.is_right"><van-icon name="success" />回答正确</span>
                    <span class="error" v-else><van-icon name="cross" />回答错误</span>
                    <span>正确答案：{{ JSON.parse(item.answer).join(',') }}</span>
                  </div>
                  <div class="tip" v-if="item.analysis">
                    <van-tag color="#e6f7fd" text-color="#00adef" size="medium">试题解析</van-tag>
                    <p v-html="item.analysis"></p>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </dd>
      </dl>
      <van-button type="primary" @click="onSubmit" v-if="!hasSubmit">提交答题</van-button>
      <van-button type="primary" @click="onRestart" v-else>重新答题</van-button>
    </div>
    <div class="container" v-else-if="tabActiveName === '错题集'">
      <dl class="exercise ueditor_style" ref="questions">
        <!-- 判断题 -->
        <dt v-if="errorJudgeChoice.length > 0"><span>判断题</span></dt>
        <dd v-if="errorJudgeChoice.length > 0">
          <ul>
            <li v-for="(item, index) in errorJudgeChoice" :key="item.paper_question_id">
              <div class="no">{{ index+1 }}.</div>
              <div class="content" >
                <div class="stem" v-html="item.stem"></div>
                <div class="options">
                  <van-radio-group v-model="item.selected" disabled>
                    <van-radio name="1" key="1">
                      <div class="opts_wrap">
                        <div class="opts_content"><p>对</p></div>
                      </div>
                    </van-radio>
                    <van-radio name="0" key="0">
                      <div class="opts_wrap">
                        <div class="opts_content"><p>错</p></div>
                      </div>
                    </van-radio>
                  </van-radio-group>
                </div>
                <div class="analysis">
                  <div class="answer">
                    <span class="success" v-if="item.is_right"><van-icon name="success" />回答正确</span>
                    <span class="error" v-else><van-icon name="cross" />回答错误</span>
                    <span>正确答案：{{ item.answer_str }}</span>
                  </div>
                  <div class="tip" v-if="item.analysis">
                    <van-tag color="#e6f7fd" text-color="#00adef" size="medium">试题解析</van-tag>
                    <p v-html="item.analysis"></p>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </dd>
        <!-- 单选题 -->
        <dt v-if="errorSingleChoice.length > 0"><span>单选题</span></dt>
        <dd v-if="errorSingleChoice.length > 0">
          <ul>
            <li v-for="(item, index) in errorSingleChoice" :key="item.paper_question_id">
              <div class="no">{{ index+1 }}.</div>
              <div class="content" >
                <div class="stem" v-html="item.stem"></div>
                <div class="options">
                  <van-radio-group v-model="item.selected" disabled>
                    <van-radio v-for="option in item.options" :name="option.identification" :key="option.identification">
                      <div class="opts_wrap">
                        <div class="opts_no">{{option.identification}}. </div>
                        <div class="opts_content" v-html="option.option"></div>
                      </div>
                    </van-radio>
                  </van-radio-group>
                </div>
                <div class="analysis">
                  <div class="answer">
                    <span class="success" v-if="item.is_right"><van-icon name="success" />回答正确</span>
                    <span class="error" v-else><van-icon name="cross" />回答错误</span>
                    <span>正确答案：{{ JSON.parse(item.answer).join(',') }}</span>
                  </div>
                  <div class="tip" v-if="item.analysis">
                    <van-tag color="#e6f7fd" text-color="#00adef" size="medium">试题解析</van-tag>
                    <p v-html="item.analysis"></p>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </dd>
        <!-- 多选题 -->
        <dt v-if="errorMultipleChoice.length > 0"><span>多选题</span></dt>
        <dd v-if="errorMultipleChoice.length > 0">
          <ul>
            <li v-for="(item, index) in errorMultipleChoice" :key="item.paper_question_id">
              <div class="no">{{ index+1 }}.</div>
              <div class="content" >
                <div class="stem" v-html="item.stem"></div>
                <div class="options">
                  <van-checkbox-group v-model="item.selected" disabled>
                    <van-checkbox shape="square" :name="option.identification" v-for="option in item.options" :key="option.identification">
                      <div class="opts_wrap">
                        <div class="opts_no">{{option.identification}}. </div>
                        <div class="opts_content" v-html="option.option"></div>
                      </div>
                    </van-checkbox>
                  </van-checkbox-group>
                </div>
                <div class="analysis">
                  <div class="answer">
                    <span class="success" v-if="item.is_right"><van-icon name="success" />回答正确</span>
                    <span class="error" v-else><van-icon name="cross" />回答错误</span>
                    <span>正确答案：{{ JSON.parse(item.answer).join(',') }}</span>
                  </div>
                  <div class="tip" v-if="item.analysis">
                    <van-tag color="#e6f7fd" text-color="#00adef" size="medium">试题解析</van-tag>
                    <p v-html="item.analysis"></p>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </dd>
      </dl>
    </div>
  </div>
</template>
<script>
  import {listPapaerQuestion, submitTest, clearPaperAnswer} from "api/question/list"
  export default {
    props: {
      paper_ids: Array,
      cur_name: String,
    },
    data() {
      return {
        showPicker: false,
        tabNames: ['全部', '错题集'],
        paper_id: this.paper_ids[0],
        tabActiveName: '全部',
        singleChoiceList: [],
        multipleChoice: [],
        judgeChoice: [],
        errorSingleChoice: [],
        errorMultipleChoice: [],
        errorJudgeChoice: [],
        radio: '0',
        checkList: [],
        hasSubmit: false,
        rightNum: '-',
        errorNum: '-',
        acc: '-',
        notSubmit: true
      }
    },
    mounted(){
      this.listQuestions()
    },
    methods: {
      tabConfirm(val) {
        this.tabActiveName = val
        if(val === '错题集') {
          this.getErrorQuestions()
        }
        this.showPicker = false
      },
      listQuestions() {
        const that = this
        let filters = {need_answer: true, total: true}
        that.hasSubmit = false
        listPapaerQuestion(this.paper_id, filters).then(res => {
          that.singleChoiceList = res.single_choice_list
          that.multipleChoice = res.multi_choice_list
          that.judgeChoice = res.true_false_list
          let right_num = 0, error_num = 0, acc = 0
          that.singleChoiceList.forEach(item => {
            if(item.user_answer) {
              item.hasSubmit = true
              item.selected = item.user_answer.answer
              item.is_right = item.user_answer.is_right
              if(item.user_answer.is_right === true){
                right_num ++
              }
              else if(item.user_answer.is_right === false){
                error_num ++
              }
            }
          })
          that.multipleChoice.forEach(item => {
            if(item.user_answer) {
              that.hasSubmit = true
              item.selected = item.user_answer.answer.split(',')
              item.is_right = item.user_answer.is_right
              if(item.user_answer.is_right === true){
                right_num ++
              }
              else if(item.user_answer.is_right === false){
                error_num ++
              }
            }
          })
          that.judgeChoice.forEach(item => {
            if(item.user_answer) {
              that.hasSubmit = true
              item.selected = item.user_answer.answer
              item.is_right = item.user_answer.is_right
              if(item.user_answer.is_right === true){
                right_num ++
              }
              else if(item.user_answer.is_right === false){
                error_num ++
              }
              let answer = JSON.parse(item.answer)
              item.answer_str = answer[0] == 1 ? '对' : '错'
            }
          })
          if(that.hasSubmit){
            that.rightNum = right_num
            that.errorNum = error_num
            that.acc = (right_num * 100 / (right_num + error_num)).toFixed(2)
          }
          else {
            that.rightNum = '-'
            that.errorNum = '-'
            that.acc = '-'
          }
        })
      },
      getErrorQuestions() {
        let filters = {
          paper_id: this.paper_id,
          need_answer: true,
          is_right: false
        }
        const that = this
        listPapaerQuestion(this.paper_id, filters).then(res => {
          that.errorSingleChoice = res.single_choice_list
          that.errorMultipleChoice = res.multi_choice_list
          that.errorJudgeChoice = res.true_false_list
          that.errorSingleChoice.forEach(item => {
            item.selected = item.user_answer.answer
          })
          that.errorMultipleChoice.forEach(item => {
            item.selected = item.user_answer.answer.split(',')
          })
          that.errorJudgeChoice.forEach(item => {
            item.selected = item.user_answer.answer
            let answer = JSON.parse(item.answer)
            item.answer_str = answer[0] == 1 ? '对' : '错'
          })
        })
      },
      onSubmit() {
        let data = []
        let right_num = 0, error_num = 0, acc = 0
        this.singleChoiceList.forEach((item) => {
          let is_right = false
          if(item.selected == JSON.parse(item.answer)[0]){
            is_right = true
            right_num ++
          }
          else {
            error_num ++
          }
          item.is_right = is_right
          data.push({
            paper_id: this.paper_id,
            question_id: item.id,
            answer: item.selected,
            is_right: is_right
          })
        })
        this.multipleChoice.forEach((item) => {
          let is_right = false
          let answer = JSON.parse(item.answer).sort()
          if(item.selected.sort().join(',') == answer.join(',')){
            is_right = true
            right_num ++
          }
          else {
            error_num ++
          }
          item.is_right = is_right
          data.push({
            paper_id: this.paper_id,
            question_id: item.id,
            answer: item.selected.join(','),
            is_right: is_right
          })
        })
        this.judgeChoice.forEach((item) => {
          console.log(item)
          let is_right = false
          let answer = JSON.parse(item.answer)
          if(item.selected == answer[0]){
            is_right = true
            right_num ++
          }
          else {
            error_num ++
          }
          item.is_right = is_right
          item.answer_str = answer[0] == 1 ? '对' : '错'
          data.push({
            paper_id: this.paper_id,
            question_id: item.id,
            answer: item.selected,
            is_right: is_right
          })
        })
        const that = this
        let post_data = {
          cur_name: this.cur_name,
          values: data
        }
        submitTest(post_data).then(res => {
          if(res.code == 0){
            that.hasSubmit = true
            that.rightNum = right_num
            that.errorNum = error_num
            that.acc = (right_num * 100 / (right_num + error_num)).toFixed(2)
          }
        })
      },
      onRestart() {
        const that = this
        clearPaperAnswer(that.paper_id).then(res => {
          if(res.code == 0){
            that.listQuestions()
          }
        })
      },
    },
    watch:{
      paper_ids(val){
        this.paper_id = val[0]
        this.tabActiveName = '全部'
        this.listQuestions()
      }
    }
  }
</script>

<style lang="scss">
  @import "~@/assets/css/ueditor.scss";
</style>
<style lang="scss" scoped>
  .alert {
    padding:10px;
    background:#f4f4f5;
    margin-bottom:15px;
  }
  dl.exercise {
    margin:0;
    dt {
      margin-bottom:15px;
      > span {
        padding:5px 15px;
        background:#ff9900;
        font-size:12px;
        color:#fff;
        position:relative;
        &:before {
          content:'';
          width:2px;
          position:absolute;
          left:3px;
          top:0;
          bottom:0;
          background:#fff;
        }
      }
    }
    dd {
      margin:0;
      ul {
        li {
          display:flex;
          line-height:1.5;
          color:#333;
          padding-bottom:10px;
          border-bottom:1px solid #f2f2f2;
          margin-bottom:15px;
          .no {
            width:40px;
            font-size:16px;
            margin-right:10px;
            text-align: center;
          }
          .content {
            flex: 1;
            :deep(.stem) {
              margin-bottom:10px;
              font-size:16px;
              p {
                margin-top:0;
                img {
                  max-width:100%;
                }
              }
            }
            :deep(.options) {
              .van-radio, .van-checkbox {
                align-items: start;
                margin-bottom: 15px;
              }
              .opts_wrap {
                display:flex;
                color:#666;
                .opts_no {
                  margin-right:5px;
                }
                .opts_content {
                  p {
                    margin:0;
                  }
                  img {
                    max-width:100%;
                  }
                }

              }
            }
          }
        }
      }
    }
  }
  .analysis {
    padding: 15px;
    font-size: 12px;
    background: #f8f8f8;

    .answer {
      > span {
        margin-right: 20px;

        > i {
          margin-right: 5px;
        }

        &.success {
          color: #6ecd3f;
        }

        &.error {
          color: #f51c21;
        }
      }
    }
    .tip {
      margin-top: 15px;
      .van-tag {
        margin-bottom: 10px;
      }
      > p {
        margin: 0;
      }
    }
  }
</style>
